import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from 'reactstrap';

import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker.js";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";
import moment from 'moment';
import { format, formatCurrency } from '../../../functions/functions';

class TableCuotasEspeciales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cuotas: this.props.cuotas,
            selectedRow: null
        }
    }

    static propTypes = {
        cuotas: PropTypes.array,
        onChange: PropTypes.func,
        disabled: PropTypes.bool
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cuotas !== this.props.cuotas) {
            this.setState({ cuotas: this.props.cuotas });
        }
    }

    onChange = data => {
        this.setState(
            prevState => ({
                cuotas: prevState.cuotas.concat(data)
            }),
            () => this.props.onChange(this.state.cuotas)
        );
    }

    onEdit = (row, data) => {
        this.setState(
            prevState => {
                prevState.cuotas[row]=data;
                return {
                    cuotas: prevState.cuotas,
                    selectedRow: null
                }
            },
            () => this.props.onChange(this.state.cuotas)
        );
    }

    onDelete = row => {
        this.setState(
            prevState => {
                prevState.cuotas.splice(row, 1);
                return {
                    cuotas: prevState.cuotas,
                    selectedRow: null
                }
            },
            () => this.props.onChange(this.state.cuotas)
        );
    }

    render() {
        const { cuotas, selectedRow } = this.state;
        const { disabled } = this.props;
        return (
            <div className="mt-2">
                { !disabled &&
                    <Fragment>
                        <ModalCuotasEspeciales
                            onChange={this.onChange}
                            action="create"
                        />
                        <ModalCuotasEspeciales
                            onEdit={this.onEdit}
                            value={cuotas[selectedRow]}
                            row={selectedRow}
                            action="edit"
                        />
                        <ModalCuotasEspeciales
                            onDelete={this.onDelete}
                            value={cuotas[selectedRow]}
                            row={selectedRow}
                            action="delete"
                        />
                    </Fragment>
                }
                <ModalCuotasEspeciales
                    value={cuotas[selectedRow]}
                    row={selectedRow}
                    action="detail"
                />
                <Table size="sm" className="mt-1">
                    <thead>
                        <tr>
                            <th>Monto</th>
                            <th>Vencimiento</th>
                        </tr>
                    </thead>
                    <tbody>
                        { cuotas.map(
                            (cuotas, i) =>
                                <tr
                                    key={i}
                                    onClick={() => this.setState(prevState => ({
                                        selectedRow: prevState.selectedRow === i ? null : i
                                    }))}
                                    className={'ui-selectable-row' + (selectedRow === i ? ' is-selected' : '')}
                                >
                                    <td>{format(cuotas.monto)}</td>
                                    <td>{cuotas.vencimiento.format('DD/MM/YYYY')}</td>
                                </tr>
                            )
                        }
                        { cuotas.length === 0 &&
                            <tr>
                                <td className="text-center" colSpan={3}>No hay cuotas especiales</td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>
        );
    }
}

class ModalCuotasEspeciales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            //monto: format(0),
            monto: '0,00',
            vencimiento: moment(new Date()),
            isOpen: false
        }
    }

    static propTypes = {
         error: PropTypes.any,
        action: PropTypes.string.isRequired,
		onChange: PropTypes.func,
        onDelete: PropTypes.func,
        onEdit: PropTypes.funct,
        disabled: PropTypes.bool
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                monto: (nextProps.value.monto).toString(),
                vencimiento: nextProps.value.vencimiento,
            });
        }
    }

    actionData = {
        delete: {
            icon: 'fa fa-minus',
            color: 'danger',
            title: 'Eliminar cuota especial',
            button: 'Eliminar',
            disabled: true,
        },
        create: {
            icon: 'fa fa-plus',
            color: 'success',
            title: 'Agregar cuota especial',
            button: 'Agregar',
            disabled: false,
        },
        detail: {
            icon: 'fa fa-search',
            color: 'secondary',
            title: 'Ver cuota especial',
            button: false,
            disabled: true,
        },
        edit: {
            icon: 'fa fa-pencil',
            color: 'success',
            title: 'Editar cuota especial',
            button: 'Editar',
            disabled: false,
        },
    };

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    close = () => {
        this.setState({
            monto: '0,00',
            vencimiento: moment(new Date()),
        });
        this.toggle();
    }

    onChangeField = (field, value) => {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

	validateFields = () =>{
          var that = this;
		var setErrors = function(field, code, detail){
			that.setState(
				prevState => {
					prevState.errors[field] = [{
						code: code.toString(),
						detail: detail.toString()
					}];
					return prevState;
            })
		};
		var errors = 0;
		const { vencimiento, monto } = this.state;
		if(vencimiento === undefined || vencimiento == null || vencimiento.isValid() == false){
               errors++;
               setErrors('vencimiento','invalid',"Fecha de Vencimiento no valida");
          }
		if(monto === undefined || monto === null || monto.toString().match(/^[0-9]+$/) == false){
               errors++;
               setErrors('monto', 'invalid', "Monto ingresado no valido");
          }
		return errors == 0;
	}

    onSubmit = () => {
        const { action, row } = this.props;
        if (action === 'create') {
			if(this.validateFields()){
				const { vencimiento, monto } = this.state;
				var today = moment(new Date(new Date().setHours(0, 0, 0, 0)));
				if(vencimiento.isSameOrAfter(today) == false)
                    alert("Advertencia - Fecha de Vencimiento inferior a hoy");
				this.props.onChange({ vencimiento, monto });
				this.close();
			}
        } else if (action === 'edit') {
			if(this.validateFields()){
				const { vencimiento, monto } = this.state;
				var today = moment(new Date(new Date().setHours(0, 0, 0, 0)));
				if(vencimiento.isSameOrAfter(today) == false)
                    alert("Advertencia - Fecha de Vencimiento inferior a hoy");
				this.props.onEdit(row, { vencimiento, monto });
				this.close();
			}
        } else if (action === 'delete') {
            this.props.onDelete(row);
			this.close();
        }
    }

    render() {
        const { isOpen } = this.state;
        const { action, disabled, row } = this.props;
        const actionData = this.actionData[action];
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        return (
            <Fragment>
                { !disabled &&
                    <Button
                        color={actionData['color']}
                        onClick={this.toggle}
                        size="sm"
                        className="mr-1"
                        disabled={(action === 'detail' || action === 'delete' || action === 'edit') && (row === null)}
                    >
                        <i className={actionData['icon']} aria-hidden="true"></i>
                    </Button>
                }

                <Modal isOpen={isOpen} toggle={this.toggle} className="ui-paradigma-modal">
                    <ModalHeader toggle={this.toggle}>
                        { actionData['title'] }
                    </ModalHeader>
                    <ModalBody>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Datos de la cuota</p>
                            <div className="ui-form-grid">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Vencimiento"}
                                    error = {()=>this.getError('vencimiento')}
                                    inputComponent={
                                        <ParadigmaDatePicker
                                            disabled={actionData['disabled']}
                                            value={ this.state.vencimiento === undefined || this.state.vencimiento === null || this.state.vencimiento.isValid() == false ? moment(new Date()) : this.state.vencimiento }
                                            onChange={data => this.onChangeField('vencimiento', data)}
                                        />
                                    }
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Monto"}
                                    error = {()=>this.getError('monto')}
                                    inputComponent={
                                        <ParadigmaCurrencyInput
                                            disabled={actionData['disabled']}
                                            className="form-control monto w-100"
                                            value={formatCurrency(this.state.monto)}
                                            onChange={data => this.onChangeField('monto', data)}
                                        />
                                    }
                                />
                            </div>
                        </section>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Cancelar</Button>
                        { actionData['button'] &&
                            <Button color={actionData['color']} onClick={this.onSubmit}>
                                {actionData['button']}
                            </Button>
                        }
                    </ModalFooter>
                </Modal>

            </Fragment>
        );
    }
}

export default TableCuotasEspeciales;



// WEBPACK FOOTER //
// ./src/views/Servicios/Servicios/TableCuotasEspeciales.js